"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isNode = () => typeof global["window"] === "undefined";
exports.isDev = () => {
    var _a;
    if (isNode() && ((_a = process.env.NODE_ENV) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== "production") {
        return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (globalThis["__DEV__"] === true) {
        return true;
    }
    return false;
};
function runDev(f, default_) {
    if (!exports.isDev()) {
        return (default_ !== null && default_ !== void 0 ? default_ : undefined);
    }
    return f();
}
exports.runDev = runDev;
function runDevAsync(f, default_) {
    if (!exports.isDev()) {
        return (default_ !== null && default_ !== void 0 ? default_ : Promise.resolve(undefined));
    }
    return f();
}
exports.runDevAsync = runDevAsync;
function runProd(f, default_) {
    if (exports.isDev()) {
        return (default_ !== null && default_ !== void 0 ? default_ : undefined);
    }
    return f();
}
exports.runProd = runProd;
function runProdAsync(f, default_) {
    if (exports.isDev()) {
        return (default_ !== null && default_ !== void 0 ? default_ : Promise.resolve(undefined));
    }
    return f();
}
exports.runProdAsync = runProdAsync;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGV2LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWwvZGV2LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsOERBQThEO0FBQzlELE1BQU0sTUFBTSxHQUFHLEdBQUcsRUFBRSxDQUFDLE9BQVEsTUFBYyxDQUFDLFFBQVEsQ0FBQyxLQUFLLFdBQVcsQ0FBQTtBQUV4RCxRQUFBLEtBQUssR0FBRyxHQUFHLEVBQUU7O0lBQ3RCLElBQUksTUFBTSxFQUFFLElBQUksT0FBQSxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsMENBQUUsV0FBVyxRQUFPLFlBQVksRUFBRTtRQUNsRSxPQUFPLElBQUksQ0FBQTtLQUNkO0lBRUQsOERBQThEO0lBQzlELElBQUssVUFBa0IsQ0FBQyxTQUFTLENBQUMsS0FBSyxJQUFJLEVBQUU7UUFDekMsT0FBTyxJQUFJLENBQUE7S0FDZDtJQUVELE9BQU8sS0FBSyxDQUFBO0FBQ2hCLENBQUMsQ0FBQTtBQUlELFNBQWdCLE1BQU0sQ0FBSSxDQUFVLEVBQUUsUUFBWTtJQUM5QyxJQUFJLENBQUMsYUFBSyxFQUFFLEVBQUU7UUFDVixRQUFPLFFBQVEsYUFBUixRQUFRLGNBQVIsUUFBUSxHQUFJLFNBQVMsRUFBQTtLQUMvQjtJQUVELE9BQU8sQ0FBQyxFQUFFLENBQUE7QUFDZCxDQUFDO0FBTkQsd0JBTUM7QUFJRCxTQUFnQixXQUFXLENBQ3ZCLENBQW1CLEVBQ25CLFFBQXFCO0lBRXJCLElBQUksQ0FBQyxhQUFLLEVBQUUsRUFBRTtRQUNWLFFBQU8sUUFBUSxhQUFSLFFBQVEsY0FBUixRQUFRLEdBQUksT0FBTyxDQUFDLE9BQU8sQ0FBQyxTQUFTLENBQUMsRUFBQTtLQUNoRDtJQUVELE9BQU8sQ0FBQyxFQUFFLENBQUE7QUFDZCxDQUFDO0FBVEQsa0NBU0M7QUFJRCxTQUFnQixPQUFPLENBQUksQ0FBVSxFQUFFLFFBQVk7SUFDL0MsSUFBSSxhQUFLLEVBQUUsRUFBRTtRQUNULFFBQU8sUUFBUSxhQUFSLFFBQVEsY0FBUixRQUFRLEdBQUksU0FBUyxFQUFBO0tBQy9CO0lBRUQsT0FBTyxDQUFDLEVBQUUsQ0FBQTtBQUNkLENBQUM7QUFORCwwQkFNQztBQUlELFNBQWdCLFlBQVksQ0FDeEIsQ0FBbUIsRUFDbkIsUUFBcUI7SUFFckIsSUFBSSxhQUFLLEVBQUUsRUFBRTtRQUNULFFBQU8sUUFBUSxhQUFSLFFBQVEsY0FBUixRQUFRLEdBQUksT0FBTyxDQUFDLE9BQU8sQ0FBQyxTQUFTLENBQUMsRUFBQTtLQUNoRDtJQUVELE9BQU8sQ0FBQyxFQUFFLENBQUE7QUFDZCxDQUFDO0FBVEQsb0NBU0MifQ==